import dayjs from 'dayjs';
import { useMemo } from 'react';

import type { OfflineEvent } from '@/api/offlineEvents';
import { Text } from '@/components/typography';
import { DateISOFormat, MonthDateFormat } from '@/constants';

import NonDigitalEventsTimelineChartTooltipLinks from './NonDigitalEventsTimelineChartTooltipLinks';

type Props = {
  events: OfflineEvent[];
  name: string;
};

type DailyGroupedEvents = Record<string, OfflineEvent[]>;

const NonDigitalEventsTimelineChartTooltip = ({ events }: Props) => {
  const dailyGroupedEvents = useMemo(
    () =>
      events.reduce<DailyGroupedEvents>((memo, e) => {
        const date = dayjs(e.eventDate).format(DateISOFormat);
        if (memo[date] == null) {
          memo[date] = [];
        }
        memo[date].push(e);
        return memo;
      }, {}),
    [events],
  );

  return (
    <tbody>
      <tr>
        <td>
          {Object.keys(dailyGroupedEvents).map((date) => {
            const dailyEvents = dailyGroupedEvents[date];
            return (
              <div key={date}>
                <Text variant="body2" color="white">
                  {dayjs(date).format(MonthDateFormat)}:{' '}
                </Text>
                <NonDigitalEventsTimelineChartTooltipLinks events={dailyEvents} />
              </div>
            );
          })}
        </td>
      </tr>
    </tbody>
  );
};

export default NonDigitalEventsTimelineChartTooltip;
